import { FC } from "react";
import { TransactionDueDateMainComponent } from "../../components/transactionDueDate/transactionDueDateMainComponent";

export const TransactionDueDatePage: FC = () => {
  //#region html
  return <TransactionDueDateMainComponent />;
  //#endregion
};
